import { TeamModel } from '@modules/team/team-model';

const { fields } = TeamModel;

export default [
  fields.name,
  fields.logo,
];
